import axios from 'axios';
export const postPasswordAPI = async (apiurl, payload, token = null) => {
    const url = `${process.env.REACT_APP_BASE_URL}${apiurl}`;
  const headers = {
    'Accept':"application/json",
  }
  if(token){
    headers.Authorization = `Bearer ${token}`
  }

  const getResponse = await axios.post(`${url}`,payload,{
    headers:headers,
  }).then(function (result) {
    return result;
  }).catch((e)=>e.response);

  return getResponse;
};